import type { ReactNode } from "react";
import { Icon, type IconName } from "../../icons";

type AlertTone = "info" | "success" | "warning" | "danger";

const ALERT_ICON: Record<AlertTone, IconName> = {
  info: "info",
  success: "checkCircle",
  warning: "alert",
  danger: "alertCircle",
};

export interface AlertProps {
  tone?: AlertTone;
  title?: ReactNode;
  children?: ReactNode;
  icon?: IconName;
  shaking?: boolean;
  className?: string;
}

/** Problems and warnings interrupt screen readers; information and success are announced politely. */
function alertRole(tone: AlertTone): "alert" | "status" {
  return tone === "danger" || tone === "warning" ? "alert" : "status";
}

export function Alert({ tone = "info", title, children, icon, shaking, className }: AlertProps): React.JSX.Element {
  return (
    <div className={`nb-alert nb-alert-${tone}${shaking ? " is-shaking" : ""}${className ? ` ${className}` : ""}`} role={alertRole(tone)}>
      <Icon name={icon ?? ALERT_ICON[tone]} />
      <div className="nb-alert-body">
        {title ? <strong className="nb-alert-title">{title}</strong> : null}
        {children ? <div className="nb-alert-text">{children}</div> : null}
      </div>
    </div>
  );
}
